import { useState, useEffect, useContext, useCallback, useRef } from "react";
import { Link } from "react-router-dom";

import lightenColor from "../lightenColor";

import { useHttpClient } from "../../../../../shared/hooks/http-hook";
import { AuthContext } from "../../../../../shared/context/auth-context";
import { ClinicaContext } from "../../../../../shared/context/clinica-context";
import SeletorUnidadeDados, {
  TODAS_UNIDADES,
} from "../../../../../shared/components/badgeUnidade/SeletorUnidadeDados";
import BadgeUnidade from "../../../../../shared/components/badgeUnidade/BadgeUnidade";
import {
  paramsUnidadeDados,
  podeAlterarRegisto,
  motivoBloqueioUnidade,
} from "../../../../../shared/util/unidadeRegisto";

//MUI TABLE
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

//Mui button dropdown
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
//

//Mui Select data
//MUI
import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";

import { format, addDays, subDays, isSameDay } from "date-fns";
import { ptBR } from "date-fns/locale";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

import { useLoading } from "../../../../../shared/context/LoadingContext";
import ObservacoesAgendamentoTooltip from "../../../components/observacoesAgendamentoTooltirp/ObservacoesAgendamentoTooltip";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

function MarcacoesAssistente({ verPdf, listaPresencaProp }) {
  const { startLoading, stopLoading } = useLoading();

  const [marcacoes, setMarcacoes] = useState();
  const [allMarcacoes, setAllMarcacoes] = useState();
  const [allMarcacoesSpecificDate, setAllMarcacoesSpecificDate] = useState([]);

  const [dataSelectAtendimentosDe, setDataSelectAtendimentosDe] = useState(
    format(new Date(), "dd-MM-yyyy"),
  );
  const [medicosSelectValue, setMedicosSelectValue] = useState("todos");
  const [nrMarcacoes, setNrMarcacoes] = useState(0);
  const [dataDatePicker, setDataDatePicker] = useState(new Date());
  const [showDatePicker, setShowDatePicker] = useState(false);
  const { sendRequest } = useHttpClient();
  const [verAtendidos, setVerAtendidos] = useState(false);
  const auth = useContext(AuthContext);

  /* De que unidade são as marcações deste ecrã. Arranca na da sessão: quem
     está ao balcão trabalha num sítio concreto.
     Fica depois do `auth` de propósito — o inicializador lê-o. */
  const [unidadeDados, setUnidadeDados] = useState(
    () => auth.estabelecimento?._id ?? null,
  );
  const verTodasUnidades = unidadeDados === TODAS_UNIDADES;

  // O intervalo em vista. Ver a nota no `fetchMarcacoesAssistente`.
  const intervaloEmVista = useRef({ startDate: null, endDate: null });
  const clinica = useContext(ClinicaContext);
  const [listaPresenca, setListaPresenca] = useState([]);
  const [clienteRecemChegado, setClienteRecemChegado] = useState(null);

  //Mui Button adicionar
  const [anchorEl, setAnchorEl] = useState(null);
  const openDropdown = Boolean(anchorEl);

  const [imprimirDialogOpen, setImprimirDialogOpen] = useState(false);
  const [medicoParaImprimir, setMedicoParaImprimir] = useState(null);

  const handleClickDropdown = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseDropdown = () => {
    setAnchorEl(null);
  };

  const handleImprimir = (idMedico) => {
    setMedicoParaImprimir(idMedico);
    setImprimirDialogOpen(true);
    handleCloseDropdown();
  };

  const confirmarImpressao = (incluirObservacoes) => {
    verPdf(
      medicoParaImprimir,
      marcacoes,
      dataSelectAtendimentosDe === "escolher-data"
        ? format(dataDatePicker, "dd-MM-yyyy")
        : dataSelectAtendimentosDe,
      incluirObservacoes,
    );
    setImprimirDialogOpen(false);
    setMedicoParaImprimir(null);
  };

  useEffect(() => {
    // Só detectar novos clientes se já tínhamos uma lista anterior
    if (
      listaPresenca.length > 0 &&
      listaPresencaProp.length > listaPresenca.length
    ) {
      const novoCliente = listaPresencaProp.find(
        (novoItem) =>
          !listaPresenca.some(
            (antigoItem) => antigoItem.clienteId === novoItem.clienteId,
          ),
      );

      if (novoCliente) {
        setClienteRecemChegado(novoCliente.clienteId);

        // Remover o destaque após 5 segundos
        setTimeout(() => {
          setClienteRecemChegado(null);
        }, 5000);
      }
    }

    setListaPresenca(listaPresencaProp);
  }, [listaPresencaProp, listaPresenca, marcacoes]);

  useEffect(() => {
    if (auth.usuariosAssociados && auth.usuariosAssociados.length === 1)
      setMedicosSelectValue(auth.usuariosAssociados[0].id);

    const fetchMarcacoesAndListaPresenca = async () => {
      try {
        startLoading();
        const today = new Date();
        const ontem = new Date();
        const amanha = new Date();
        ontem.setDate(today.getDate() - 1);
        amanha.setDate(today.getDate() + 1);

        const tempMarcacoesDaFuncao = await fetchMarcacoesAssistente(
          ontem,
          amanha,
        );

        const tempAllMarcacoes = [...tempMarcacoesDaFuncao];

        const tempMarcacoes = tempAllMarcacoes.filter(
          (mr) =>
            format(new Date(mr.data_inicio_execucao), "dd-MM-yyyy") ===
            format(new Date(), "dd-MM-yyyy"),
        );

        const sortedAllMarcacoes = tempAllMarcacoes.sort((a, b) => {
          return (
            new Date(a.data_inicio_execucao) - new Date(b.data_inicio_execucao)
          );
        });

        const sorteMarcacoes = tempMarcacoes.sort((a, b) => {
          return (
            new Date(a.data_inicio_execucao) - new Date(b.data_inicio_execucao)
          );
        });

        setAllMarcacoes(sortedAllMarcacoes);
        setNrMarcacoes(sorteMarcacoes.length);
        setMarcacoes(sorteMarcacoes);
      } catch (err) {
        console.error("err", err);
      } finally {
        stopLoading();
      }
    };

    fetchMarcacoesAndListaPresenca();

    fetchMarcacoesAndListaPresenca();
  }, [sendRequest, clinica, auth]);

  const fetchMarcacoesAssistente = async (
    startDate,
    endDate,
    unidade = unidadeDados,
  ) => {
    const marcacoesTrabalhadas = [];

    // O intervalo em vista, para o seletor de unidade poder repetir o pedido.
    intervaloEmVista.current = { startDate, endDate };

    try {
      startLoading();
      const formData = new FormData();
      formData.append(
        "medicos",
        JSON.stringify(auth.usuariosAssociados.map((m) => m.id)),
      );

      formData.append("startDate", startDate);
      formData.append("endDate", endDate);

      /* Trocar de unidade é um pedido novo, não um recorte do que já veio.
         Sem parâmetros o servidor devolve a unidade da sessão. */
      for (const [chave, valor] of Object.entries(
        paramsUnidadeDados(unidade, auth),
      )) {
        formData.append(chave, valor);
      }

      const responseData = await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/agenda/marcacoessecretaria/${clinica.clinica._id}`,
        "PATCH",
        formData,
        {
          Authorization: "Bearer " + auth.token,
        },
      );

      const responseData2 = await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/agendamentosemtransicao/marcacoessecretaria/${clinica.clinica._id}`,
        "PATCH",
        formData,
        {
          Authorization: "Bearer " + auth.token,
        },
      );

      const responseDataTratamentoIsolados = await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/tratamentoIsolados/marcacoessecretaria/${clinica.clinica._id}`,
        "PATCH",
        formData,
        {
          Authorization: "Bearer " + auth.token,
        },
      );

      responseData.marcacoes.forEach((mr) => {
        marcacoesTrabalhadas.push({
          id: mr._id,
          nome: mr.cliente.nome,
          contacto: mr.cliente.contacto,
          data_inicio_execucao: mr.data_inicio_execucao,
          data_fim_execucao: mr.data_fim_execucao,
          idPlano: mr.avaliacao ? null : mr.planoTratamento,
          idCliente: mr.cliente._id,
          medico: mr.medico,
          categoriaTratamento: mr.categoriaTratamento,
          avaliacao: mr.avaliacao ? true : false,
          atendido: mr.atendido,
          faltou: mr.faltou,
          observacoesAgendamento: mr.observacoesAgendamento,
          // Sem isto a linha perde a unidade a caminho da tabela, e nem a
          // pastilha nem o bloqueio das ações têm por onde se decidir.
          estabelecimento: mr.estabelecimento,
        });
      });

      responseData2.marcacoes.forEach((mr) => {
        marcacoesTrabalhadas.push({
          id: mr._id,
          nome: mr.cliente.nome,
          contacto: mr.cliente.contacto,
          data_inicio_execucao: mr.data_inicio_execucao,
          data_fim_execucao: mr.data_fim_execucao,
          idCliente: mr.cliente._id,
          medico: mr.medico,
          categoriaTratamento: mr.categoriaTratamento,
          avaliacao: mr.avaliacao ? true : false,
          atendido: mr.atendido,
          faltou: mr.faltou,
          emTransicao: true,
          observacoesAgendamento: mr.observacoesAgendamento,
          // Sem isto a linha perde a unidade a caminho da tabela, e nem a
          // pastilha nem o bloqueio das ações têm por onde se decidir.
          estabelecimento: mr.estabelecimento,
        });
      });

      responseDataTratamentoIsolados.tratamentoIsolados.forEach((trIsl) => {
        marcacoesTrabalhadas.push({
          id: trIsl._id,
          nome: trIsl.cliente.nome,
          contacto: trIsl.cliente.contacto,
          data_inicio_execucao: trIsl.data_inicio_execucao,
          data_fim_execucao: trIsl.data_fim_execucao,
          idCliente: trIsl.cliente._id,
          medico: trIsl.medico,
          atendido: trIsl.atendido,
          faltou: trIsl.faltou,
          tratamentoIsolado: true,
          observacoesAgendamento: trIsl.observacoesAgendamento,
          tratamento:
            trIsl.tratamento?.designacao ||
            trIsl.categoriaTratamento?.categoria,
          /* Faltava só nos isolados — as linhas da agenda e as de transição já
             o traziam. Sem unidade na linha, a `podeAlterarRegisto` devolve
             `true` por tolerância e a linha nunca era bloqueada. */
          estabelecimento: trIsl.estabelecimento,
        });
      });
    } catch (err) {
      console.error(err);
    } finally {
      stopLoading();
    }
    return marcacoesTrabalhadas;
  };

  /* O quarto argumento existe para quem acabou de ir buscar dados novos ao
     servidor e ainda não os vê no estado. `allMarcacoes` só muda na passagem
     SEGUINTE, por isso quem trocou de unidade e filtrasse já estaria a filtrar
     a unidade anterior. Sem ele, o seletor de unidade vinha com a lista vazia.
     Quem não o passa continua a ler o estado, como sempre. */
  const filterMarcacoes = useCallback(
    (
      medico,
      data,
      marcacoesSpecificDate = [...allMarcacoesSpecificDate],
      todasAsMarcacoes = allMarcacoes,
    ) => {
      let tempMarcacoes;
      let temp;
      if (data === "escolher-data") {
        if (medico === "todos") {
          temp = [...marcacoesSpecificDate];
        } else {
          temp = marcacoesSpecificDate.filter((mr) => mr.medico._id === medico);
        }
      } else if (data === format(new Date(), "dd-MM-yyyy")) {
        if (medico === "todos") {
          temp = todasAsMarcacoes.filter(
            (mr) =>
              format(new Date(mr.data_inicio_execucao), "dd-MM-yyyy") === data,
          );
        } else {
          temp = todasAsMarcacoes.filter(
            (mr) =>
              mr.medico._id === medico &&
              format(new Date(mr.data_inicio_execucao), "dd-MM-yyyy") === data,
          );
        }
        temp.sort((a, b) => {
          return (
            new Date(a.data_inicio_execucao) - new Date(b.data_inicio_execucao)
          );
        });
      } else {
        if (medico === "todos") {
          temp = todasAsMarcacoes.filter(
            (mr) =>
              format(new Date(mr.data_inicio_execucao), "dd-MM-yyyy") === data,
          );
        } else {
          temp = todasAsMarcacoes.filter(
            (mr) =>
              mr.medico._id === medico &&
              format(new Date(mr.data_inicio_execucao), "dd-MM-yyyy") === data,
          );
        }
      }
      tempMarcacoes = temp.sort((a, b) => {
        return (
          new Date(a.data_inicio_execucao) - new Date(b.data_inicio_execucao)
        );
      });

      setMarcacoes(tempMarcacoes);
      setNrMarcacoes(tempMarcacoes.length);
    },
    [allMarcacoes, allMarcacoesSpecificDate],
  );

  const changeSelectAtendimentosDe = useCallback(
    (e) => {
      setDataSelectAtendimentosDe(e.target.value);
      if (e.target.value === "escolher-data") {
        setShowDatePicker(true);
      } else {
        setShowDatePicker(false);
        filterMarcacoes(medicosSelectValue, e.target.value);
      }
    },

    [filterMarcacoes, medicosSelectValue],
  );

  const changeMedicoDaLista = (e) => {
    setMedicosSelectValue(e.target.value);
    filterMarcacoes(e.target.value, dataSelectAtendimentosDe);
  };

  const handleTerminar = (id) => {
    setMarcacoes((current) => current.filter((m) => m.id !== id));
    setAllMarcacoes((current) => current.filter((m) => m.id !== id));
  };

  const changeDataDatePicker = async (value) => {
    setDataDatePicker(value);
    if (!value || isNaN(new Date(value).getTime())) return;
    startLoading();
    try {
      const formData = new FormData();
      formData.append(
        "medicos",
        JSON.stringify(auth.usuariosAssociados.map((m) => m.id)),
      );
      const tempMarcacoes = await fetchMarcacoesAssistente(value, value);

      const temp = tempMarcacoes.sort((a, b) => {
        return (
          new Date(a.data_inicio_execucao) - new Date(b.data_inicio_execucao)
        );
      });

      setAllMarcacoesSpecificDate(temp);
      setNrMarcacoes(temp.length);

      filterMarcacoes(medicosSelectValue, "escolher-data", temp);
    } catch (err) {
      console.error("err", err);
    } finally {
      stopLoading();
    }
  };

  // Função auxiliar para verificar se cliente está presente e obter horário
  const getClientePresenca = (clienteId) => {
    const presente = listaPresenca.find((item) => item.clienteId === clienteId);
    return presente || null;
  };

  // Função para formatar horário
  const formatarHorario = (horarioChegada) => {
    return format(new Date(horarioChegada), "HH:mm");
  };

  return (
    <>
      {auth && auth.usuariosAssociados && (
        <>
          <div className="marcacoes-secretaria-header-row">
            <div className="box-escolha-de-dia">
              <span className="box-title--atendimentosSecretaria">
                Atendimentos de:{" "}
              </span>
              <select
                onChange={changeSelectAtendimentosDe}
                value={dataSelectAtendimentosDe}
              >
                <option value={format(subDays(new Date(), 1), "dd-MM-yyyy")}>
                  Ontem
                </option>
                <option value={format(new Date(), "dd-MM-yyyy")}>Hoje</option>
                <option value={format(addDays(new Date(), 1), "dd-MM-yyyy")}>
                  Amanhã
                </option>
                <option value="escolher-data">Escolher Data</option>
              </select>

              {auth.usuariosAssociados.length > 1 && (
                <>
                  <span className="box-title--atendimentosSecretaria">
                    do(s) médico(s):{" "}
                  </span>
                  <select onChange={changeMedicoDaLista}>
                    <option value="todos">Todos</option>
                    {auth.usuariosAssociados.map((m) => (
                      <option value={m.id} key={m.id}>
                        {m.nome}
                      </option>
                    ))}
                  </select>
                </>
              )}

              {showDatePicker && (
                <div>
                  <LocalizationProvider
                    dateAdapter={AdapterDateFns}
                    adapterLocale={ptBR}
                    className="adicionar-despesa__modal__container--span1"
                  >
                    <DesktopDatePicker
                      className="valorDataCaixa__fields--field muiDatePicker"
                      label="Data*"
                      inputFormat="dd-MM-yyyy"
                      renderInput={(params) => <TextField {...params} />}
                      onChange={(value) => changeDataDatePicker(value)}
                      value={dataDatePicker}
                    />
                  </LocalizationProvider>
                </div>
              )}
              <span className="box-title--atendimentosSecretaria">{`${nrMarcacoes} marcações`}</span>

              {/* De que unidade são estas marcações. Trocar refaz o pedido
                  ao servidor, para o mesmo intervalo que está em vista. */}
              <SeletorUnidadeDados
                valor={unidadeDados}
                onChange={async (nova) => {
                  setUnidadeDados(nova);
                  if (!intervaloEmVista.current.startDate) return;

                  /* ─── OS DOIS CACHES TÊM DE TROCAR DE UNIDADE JUNTOS ──────
                   *
                   * Este ecrã guarda as marcações em dois sítios: a JANELA de
                   * ontem/hoje/amanhã, de onde o seletor de dia lê, e o DIA
                   * ESCOLHIDO no calendário. A troca de unidade refrescava só
                   * o que estava em vista, e o outro ficava com a unidade
                   * anterior — à espera de ser mostrado.
                   *
                   * Dava isto: estando numa unidade, escolher a outra e
                   * depois «Amanhã» mostrava o amanhã DA PRIMEIRA, porque o
                   * seletor de dia lê da janela e a janela não tinha mudado.
                   *
                   * A unidade nova vai por argumento: o `setState` ainda não
                   * se vê nesta passagem, e o pedido sairia com a antiga. */
                  const agora = new Date();
                  const ontem = subDays(agora, 1);
                  const amanha = addDays(agora, 1);

                  const janela = await fetchMarcacoesAssistente(
                    ontem,
                    amanha,
                    nova,
                  );
                  setAllMarcacoes(janela);

                  /* O resultado vai para o MESMO sítio de onde o filtro lê, e
                     só depois se filtra — em vez de ser atirado direto para a
                     lista, como estava. Assim fica com o dia em vista e com o
                     médico escolhido, em vez dos três dias todos. */
                  if (dataSelectAtendimentosDe === "escolher-data") {
                    const doDia = await fetchMarcacoesAssistente(
                      dataDatePicker,
                      dataDatePicker,
                      nova,
                    );
                    setAllMarcacoesSpecificDate(doDia);
                    filterMarcacoes(medicosSelectValue, "escolher-data", doDia);
                  } else {
                    filterMarcacoes(
                      medicosSelectValue,
                      dataSelectAtendimentosDe,
                      undefined,
                      janela,
                    );
                  }
                }}
              />

              <div
                className="checkbox-wrapper-51"
                id="ver-atendidos__checkbox-container"
              >
                <span className="box-title--atendimentosSecretaria">
                  Ver Atendidos
                </span>
                <input
                  type="checkbox"
                  id="mostrarRecebidos"
                  onChange={(e) => setVerAtendidos(e.target.checked)}
                  checked={verAtendidos}
                />
                <label htmlFor="mostrarRecebidos" className="toggle">
                  <span>
                    <svg width="10px" height="10px" viewBox="0 0 10 10">
                      <path d="M5,1 L5,1 C2.790861,1 1,2.790861 1,5 L1,5 C1,7.209139 2.790861,9 5,9 L5,9 C7.209139,9 9,7.209139 9,5 L9,5 C9,2.790861 7.209139,1 5,1 L5,9 L5,1 Z"></path>
                    </svg>
                  </span>
                </label>
              </div>
            </div>

            <div>
              <Button
                variant="contained"
                color="success"
                id="basic-button"
                aria-controls={openDropdown ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={openDropdown ? "true" : undefined}
                onClick={handleClickDropdown}
                style={{ padding: "5px 10px", fontSize: "13px" }}
              >
                Imprimir
              </Button>
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={openDropdown}
                onClose={handleCloseDropdown}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
              >
                {auth.usuariosAssociados.map((m, index) => (
                  <MenuItem
                    key={index}
                    onClick={handleImprimir.bind(null, m)}
                    style={{ padding: "5px 10px", fontSize: "14px" }}
                  >
                    {m.nome}
                  </MenuItem>
                ))}
              </Menu>
            </div>
          </div>
        </>
      )}

      {marcacoes && marcacoes.length > 0 && (
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead style={{ backgroundColor: "white" }}>
              <TableRow className="marcacoesAdministrativo__tableHeading">
                <TableCell align="left">Cliente</TableCell>
                <TableCell align="left">Médico</TableCell>
                <TableCell align="left">Procedimento</TableCell>
                <TableCell align="left">Horário Inicial</TableCell>
                <TableCell align="left">Horário Final</TableCell>
                <TableCell align="left">Presente</TableCell>
                <TableCell align="left">Obs</TableCell>
                <TableCell align="left">Ação</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {marcacoes.map((row) => {
                if (!verAtendidos && (row.atendido || row.faltou)) {
                  return null; // Skip rendering rows that don't match the condition
                }
                return (
                  <TableRow
                    key={row.id}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    className={
                      clienteRecemChegado === row.idCliente
                        ? "row-cliente-acabou-chegar"
                        : ""
                    }
                  >
                    <TableCell align="left">
                      <Link
                        to={`/clientes/${row.idCliente}`}
                        className="linkNoNomeDoCliente"
                      >
                        <span>{row.nome}</span>
                      </Link>
                      {/* Só no consolidado: com uma unidade escolhida, todas as
                          linhas são dela. */}
                      {verTodasUnidades && (
                        <BadgeUnidade estabelecimento={row.estabelecimento} />
                      )}
                    </TableCell>
                    <TableCell align="left" style={{ color: row.medico.cor }}>
                      <span
                        className="marcacoesAdministrativo__nome__medico__span"
                        style={{
                          color: row.medico.cor,
                          backgroundColor: lightenColor(
                            row.medico.cor,
                            40,
                            0.4,
                          ),
                        }}
                      >
                        {row.medico.name}
                      </span>
                    </TableCell>
                    <TableCell align="left">
                      {row.avaliacao
                        ? "Avaliação"
                        : row.tratamentoIsolado
                          ? row.tratamento
                          : row.categoriaTratamento.categoria}
                    </TableCell>
                    <TableCell align="left">
                      {format(new Date(row.data_inicio_execucao), "HH:mm")}
                    </TableCell>
                    <TableCell align="left">
                      {format(new Date(row.data_fim_execucao), "HH:mm")}
                    </TableCell>
                    {isSameDay(
                      new Date(marcacoes[0].data_inicio_execucao),
                      new Date(),
                    ) && (
                      <TableCell align="left">
                        {(() => {
                          const presenca = getClientePresenca(row.idCliente);
                          return presenca ? (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                              }}
                            >
                              <div className="cliente-presente led"></div>
                              <span className="badge-horario">
                                {formatarHorario(presenca.horarioChegada)}
                              </span>
                            </div>
                          ) : (
                            <div className="cliente-nao-presente led"></div>
                          );
                        })()}
                      </TableCell>
                    )}
                    {/* Obs */}
                    <TableCell align="left">
                      <ObservacoesAgendamentoTooltip
                        observacoes={row.observacoesAgendamento}
                      />
                    </TableCell>
                    <TableCell align="left">
                      {/* Marcação de outra unidade: só leitura. Marcar
                          presença ou falta é operação do balcão onde a pessoa
                          está — daqui seria feita às cegas sobre o outro. */}
                      {!podeAlterarRegisto(row.estabelecimento, auth) ? (
                        <span
                          className="marcacoes__outra-unidade"
                          title={motivoBloqueioUnidade(row.estabelecimento)}
                        >
                          Outra unidade
                        </span>
                      ) : row.atendido || row.faltou ? (
                        dataSelectAtendimentosDe ===
                        format(new Date(), "dd-MM-yyyy") ? (
                          <span
                            className={
                              row.atendido
                                ? "spanMensagemAtendido"
                                : "spanMensagemFaltou"
                            }
                            onClick={handleTerminar.bind(null, row.id)}
                          >
                            {row.atendido ? "Atendido" : "Faltou"}
                          </span>
                        ) : null
                      ) : row.avaliacao ? (
                        /* A auxiliar é quem normalmente cria a avaliação, e o
                           botão só existia na lista do dentista. A rota já
                           autorizava o papel Assistente — faltava a porta.
                           Como na lista do dentista, aparece em qualquer data
                           e desaparece assim que a marcação é dada como
                           atendida ou falhada. */
                        <Link
                          to={`/avaliacao/new/${row.idCliente}-${row.id}`}
                          className="linkProcedimento"
                        >
                          <button className="executarButton">Avaliar</button>
                        </Link>
                      ) : null}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      {marcacoes && marcacoes.length === 0 && (
        <span className="nenhumProcedimentoMsg">
          Nenhum procedimento por mostrar
        </span>
      )}

      {/* Modal para escolher se imprime com ou sem observações */}
      <Dialog
        open={imprimirDialogOpen}
        onClose={() => setImprimirDialogOpen(false)}
        aria-labelledby="imprimir-dialog-title"
      >
        <DialogTitle id="imprimir-dialog-title">
          Opções de Impressão
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Deseja incluir as observações na impressão?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setImprimirDialogOpen(false)}>Cancelar</Button>
          <Button onClick={() => confirmarImpressao(false)} color="primary">
            Sem Observações
          </Button>
          <Button
            onClick={() => confirmarImpressao(true)}
            color="primary"
            variant="contained"
          >
            Com Observações
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default MarcacoesAssistente;
